import React from 'react'
import { AppRouteURI, AppRoutingRoles } from 'router/RoleBasedAccess'
import App from '../../components/app/App'
import AnalyticsContainer from './AnalyticsContainer'

export default () => {
    const { isProtected, checkRoles } = {
        ...AppRoutingRoles[AppRouteURI.ANALYTICS],
    }
    return (
        <App isProtected={isProtected} checkRoles={checkRoles}>
            <AnalyticsContainer />
        </App>
    )
}
